import { render, staticRenderFns } from "./TheNavigation.vue?vue&type=template&id=5254dba2&scoped=true"
import script from "./TheNavigation.vue?vue&type=script&lang=js"
export * from "./TheNavigation.vue?vue&type=script&lang=js"
import style0 from "./TheNavigation.vue?vue&type=style&index=0&id=5254dba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5254dba2",
  null
  
)

export default component.exports